<template>
  <div class="">

    <div class="wrap">
      <Nav></Nav>
      <div class="login-wrap padding">
        <div class="left">
          <div class="top">全线优质大牌货源汇集于此</div>
          <div class="bottom">超高折扣 推广立即赚钱</div>
        </div>
        <div class="login-action">
          <div class="login-padding">
            <div class="login-title">登录</div>
            <div class="input-wrap" :style="errorInfo.mobileWrapObj">
              <img src="../../../assets/img/login_btn_user.png" alt="">
              <input type="text" placeholder="请输入手机号" v-model.trim="nickname" @blur="checkNickname">
              <img v-show="nickname" src="../../../assets/img/login_btn_cancel.png" alt="" @click="nickname = ''">
            </div>
            <div class="input-tip" :style="errorInfo.mobileTipObj">
              <Icon type="md-alert" size="24" color="#FF4F76" />
              <span class="tip-content">{{errorInfo.mobileTip}}</span>
            </div>
            <div class="input-wrap last" :style="errorInfo.passwordWrapObj">
              <img src="../../../assets/img/login_btn_password.png" alt="">
              <input type="password" placeholder="请输入密码" v-model.trim="password" @input="checkPassword">
              <img v-show="password" src="../../../assets/img/login_btn_cancel.png" alt="" @click="password = ''">
            </div>
            <div class="input-tip" :style="errorInfo.passwordTipObj">
              <Icon type="md-alert" size="24" color="#FF4F76" />
              <span class="tip-content">{{ errorInfo.passwordTip }}</span>
            </div>
            <div class="operate-wrap">
              <div class="forget-pwd" @click="toForgetPwd">忘记密码？</div>
              <div class="to-register" @click="toRegister">注册账号</div>
            </div>
            <div class="to-login" @click="doLogin">登录</div>
          </div>
        </div>
      </div>
      <div class="step padding">步骤流程</div>
      <img src="../../../assets/img/home_steps.png" alt="" class="padding stepImg">
      <Footer></Footer>
    </div>

  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { Spin, Icon } from 'view-design'
import Footer from '@/components/Footer.vue'

export default {
  name: 'openindex',
  components: { Nav, Spin, Icon, Footer },
  props: {},
  data() {
    return {
      nickname: '',
      password: '',
      errorInfo: {
        mobileTip: '',
        passwordTip: '',
        mobileTipObj: {
          display: 'none'
        },
        passwordTipObj: {
          display: 'none'
        },
        mobileWrapObj: {
          border: '1px solid #eeeeee'
        },
        passwordWrapObj: {
          border: '1px solid #eeeeee' // ff4f76
        }
      }
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {
    //监听昵称或手机号
    checkNickname() {
      var isValidate = true
      var tip = ''
      if (this.nickname === '') {
        tip = '请填写手机号'
        isValidate = false
        return this.handelErrorTip(isValidate, 0, tip)
      }
      var numReg = /^[0-9]*$/
      var numRe = new RegExp(numReg)
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.nickname)) {
        tip = '手机号格式错误'
        isValidate = false
        return this.handelErrorTip(isValidate, 0, tip)
      }
      isValidate = true
      tip = ''
      return this.handelErrorTip(isValidate, 0, tip)
    },
    //监听密码
    checkPassword() {
      var isValidate = true
      var tip = ''
      if (this.password === '') {
        tip = '请填写密码'
        isValidate = false
        return this.handelErrorTip(isValidate, 1, tip)
      }
      if (!(this.password.length >= 6)) {
        tip = '密码长度错误'
        isValidate = false
        return this.handelErrorTip(isValidate, 1, tip)
      }
      tip = ''
      isValidate = true
      return this.handelErrorTip(isValidate, 1, tip)
    },
    toForgetPwd() {
      this.$router.push('/pc/resetPwd')
    },
    toRegister() {
      this.$router.push('/pc/register')
    },
    doLogin() {
      var isValidate = this.allValidate()
      if (isValidate === false) {
        return
      }
      this.loading = true
      var loginFormData = {
        mobile: this.nickname,
        password: this.password
      }

      this.$store
        .dispatch('user/login', loginFormData)
        .then(response => {
          this.loading = false
          this.isLogin = true
          this.nickname = this.password = ''
          this.$Message.success('登录成功')
          this.$router.push('/pc/open/home')
        })
        .catch(() => {
          this.loading = false
        })
    },
    handelErrorTip: function (isValidate, type, tip) {
      if (type == 0) {
        if (isValidate === false) {
          this.errorInfo.mobileTip = tip
          this.errorInfo.mobileTipObj.display = 'flex'
          this.errorInfo.mobileWrapObj.border = '1px solid #ff4f76'
        } else {
          this.errorInfo.mobileTip = ''
          this.errorInfo.mobileTipObj.display = 'none'
          this.errorInfo.mobileWrapObj.border = '1px solid #eee'
        }
      } else {
        if (isValidate === false) {
          this.errorInfo.passwordTip = tip
          this.errorInfo.passwordTipObj.display = 'flex'
          this.errorInfo.passwordWrapObj.border = '1px solid #ff4f76'
        } else {
          this.errorInfo.passwordTip = ''
          this.errorInfo.passwordTipObj.display = 'none'
          this.errorInfo.passwordWrapObj.border = '1px solid #eee'
        }
      }
      return isValidate
    },
    allValidate() {
      return this.checkNickname() && this.checkPassword()
    }
  }
}
</script>
<style scoped lang="less">
.wrap {
  min-width: 850px;

  .login-wrap {
    min-height: 560px;
    background-image: url(../../../assets/img/home_login_bg.png);
    background-repeat: no-repeat;
    // background-size: contain;
    background-size: cover;
    background-position: 50% 50%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;

      .top {
        font-size: 42px;
      }
      .bottom {
        font-size: 24px;
        margin-bottom: 25%;
      }
    }

    .login-action {
      background: #ffffff;
      width: 380px;
      height: 380px;
      // margin-bottom: 6%;
      
      .login-padding {
        padding: 30px 60px;
      }
      .login-title {
        font-family: Alibaba-PuHuiTi-M;
        font-size: 32px;
        color: #222222;
        line-height: 80px;
        text-align: center;
      }
      .input-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px 10px;
        background: #ffffff;
        border: 1px solid #eeeeee;
        border-radius: 2px;
        margin-top: 20px;
        img {
          cursor: pointer;
          width: 24px;
          height: 24px;
        }
        input {
          width: 90%;
          font-size: 14px;
          color: #222222;
          padding: 5px;
          border: none;
        }
      }
      .input-tip {
        margin-top: 8px;
        font-size: 12px;
        color: #ff4f76;
        letter-spacing: 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .tip-content {
          margin-left: 3px;
          color: #ff4f76;
        }
      }
      .input-tip.hidden {
        display: none;
      }
      .operate-wrap {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
        margin-top: 16px;
        width: 100%;
        overflow: hidden;
        .forget-pwd {
          float: left;
          cursor: pointer;
        }
        .to-register {
          float: right;
          cursor: pointer;
        }
      }
      .to-login {
        color: #ffffff;
        background: #ff9734;
        border-radius: 2px;
        margin-top: 20px;
        text-align: center;
        height: 48px;
        line-height: 48px;
        cursor: pointer;
      }
    }
  }
  .step {
    // display: flex;
    // justify-content: center;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 50px;
    font-size: 36px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    .title {
      font-size: 36px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
    }
  }
  .stepImg {
    width: 100%;
    margin-bottom: 100px;
  }
}

.margin {
  // margin: auto 18.75%;
  margin: auto 13.5%;
}
.padding {
  // padding: 0 18.75%;
  padding: 0 13.5%;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/login.vue